import React from 'react';
import { render } from 'react-dom';
import App from './App';
import { Router } from '@reach/router';
import SearchPage from './pages/SearchPage';
import TemplatePage from './pages/TemplatePage';
import PedigreePage from './pages/PedigreePage';
import UsersPage from './pages/UsersPage';
import { StoreProvider } from './data/Store';
import './index.css';

import Amplify, { Auth } from 'aws-amplify';
import { AmplifyAuthenticator, AmplifySignUp, AmplifySignIn } from '@aws-amplify/ui-react';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';

import awsExports from "./aws-exports";

const apiConfig = {API: {
  graphql_headers: async () => {
      const session = await Auth.currentSession();
      return { Authorization: session.getIdToken().getJwtToken() };
  }
}};
const config = {...awsExports, ...apiConfig};
Amplify.configure(awsExports);

const AuthStateApp = () => {
    const [authState, setAuthState] = React.useState();
    const [user, setUser] = React.useState();
    const [mygroups, setMygroups] = React.useState();
    const [creds, setCreds] = React.useState();
    
    const signUpFields = [
      {
        type: "email",
        label: "custom_label",
        placeholder: "Custom placeholder",
        hint: null,
        required: true,
      },
    ];

    React.useEffect(() => {
        return onAuthUIStateChange((nextAuthState, authData) => {
            setAuthState(nextAuthState);
            setUser(setACL(authData));
            setCreds(authData);
        });
    }, []);
    
    function setACL(user) {
      if (!user ||
          !user.signInUserSession ||
          !user.signInUserSession.accessToken ||
          !user.signInUserSession.accessToken.payload) return user;
      let userGroups = user.signInUserSession.accessToken.payload["cognito:groups"];
      setMygroups(userGroups);
      let group = (userGroups.includes('admin')) ? 'ADMIN' : 'USER';

      return group;
    }
    
    function signout() {
      Auth.signOut();
    }
    
  return authState === AuthState.SignedIn && user ? (
        <div>
          <StoreProvider>
            <Router basename={`${process.env.PUBLIC_URL}/`}>
              <App path={`/`} signout={signout} user={user}>
                <SearchPage default path={`${process.env.PUBLIC_URL}/`} user={user} groups={mygroups}/>
                <TemplatePage path={`${process.env.PUBLIC_URL}/template`} user={user} />
                <PedigreePage path={`${process.env.PUBLIC_URL}/pedigree/:pedigree`} user={user} />
                <UsersPage path={`${process.env.PUBLIC_URL}/admin`} creds={creds} />
              </App>
            </Router>
          </StoreProvider>
        </div>
    ) : (
      <AmplifyAuthenticator usernameAlias="email">
        <AmplifySignUp
          slot="sign-up"
          usernameAlias="email"
          formFields={[
            {
              type: "email",
              label: "Your Email",
              placeholder: "",
              required: true,
            },
            { 
              type: "password",
              label: "Create a Password",
              placeholder: "",
              required: true,
            },
            {
              type: "custom:customer-id",
              label: "Customer ID (located on Invoice)",
              placeholder: "",
              required: false,
            }
          ]} 
        />
        <AmplifySignIn slot="sign-in" usernameAlias="email" />
      </AmplifyAuthenticator>
  );
};

render(<AuthStateApp />, document.getElementById('root'));
